import { css, html } from 'lit'
import { ReportField } from '../type/modal-for-report-type'

export const ModalStylesForReports = css`
    .medium .mdc-dialog__content {
        padding: 0 !important;
    }
    .expand-container {
        display: flex;
        justify-content: center;
        align-items: center;
        position: absolute;
        margin-left: calc(100% - 55px);
        height: 20px;
        width: 20px;
        background-color: white;
        z-index: 10;
        cursor: pointer;
        pointer-events: auto;
    }

    .expand-container > svg {
        fill: var(--neutrals-grey-02, black);
        height: 90%;
        width: 90%;
    }
    .pagination-container {
        margin-left: auto;
        margin-top: 8px;
        margin-right: 10px;
    }
    .tabs {
        margin-bottom: 10px;
        border-bottom: 2px solid #dbdbdb;
    }
    .tabs-container {
        display: flex;
    }
    .tab {
        padding: 10px 20px;
        border: none;
        background: white;
        cursor: pointer;
        font-family: MaerskText;
        font-size: 20px;
        font-weight: 700;
        line-height: 24px;
        text-align: left;
        position: relative;
        z-index: 2;
    }

    .tab.active {
        font-weight: bold;
        color: black;
    }

    .tab.active::after {
        content: '';
        position: absolute;
        bottom: -2px;
        left: 0;
        right: 0;
        height: 2px;
        background: #00243d;
        z-index: 3;
    }

    .tab-content {
        padding-left: 10px;
        border-top: none;
    }

    .tab-content.visible {
        display: block;
        overflow-y: scroll;
        height: 75vh;
    }

    .group-name {
        font-weight: bold;
        margin-bottom: 20px;
        font-family: 'MaerskText';
        font-size: 16px;
    }

    .field-container {
        margin-bottom: 10px;
        margin-right: 20px;
        width: 100%;
    }

    .required-star {
        color: red;
        font-size: 1.2em;
    }
    .not-required {
        font-size: 1.2em;
    }

    .field-label {
        margin-right: 5px;
        font-size: 14px;
        color: var(--neutrals-grey-02);
        display: block;
    }
    .whole-container {
        display: grid;
        justify-content: space-between;
        grid-template-columns: repeat(4, 1fr);
        gap: 10px;
    }
    .button-container {
        display: flex;
        justify-content: flex-end;
        padding-top: 20px;
        padding-bottom: 20px;
        position: static;
        background-color: #f7f7f7;
    }
    .each-button {
        margin-left: 10px;
    }
    .field-value {
        font-weight: bold;
        margin-top: 10px;
        font-family: 'MaerskText';
        font-size: 14px;
        color: var(--neutrals-grey-02, black);
        display: block;
    }
    .field-input {
        border: none;
        border-bottom: 1px solid black;
    }
    .inputContainer {
        display: flex;
        align-items: center;
        box-sizing: border-box;
        height: 32px;
        border: 1px solid var(--neutrals-grey-06);
        background-color: var(--neutrals-grey-10, white);
        border-radius: 3px;
        margin-top: 10px;
    }

    .inputContainer:focus-within {
        box-shadow: 0px 4px 12px rgba(20, 20, 20, 0.06),
            0px 2px 4px rgba(20, 20, 20, 0.1);
    }

    .inputContainer[invalid] {
        border-left: 2px solid var(--voyage-error-red, red);
        border-top: 2px solid var(--voyage-error-red, red);
        border-bottom: 2px solid var(--voyage-error-red, red);
        border-right: 2px solid var(--voyage-error-red, red);
    }
    .inputContainer[invalid] input::placeholder,
    .inputContainer[invalid] input,
    .validation-text {
        color: var(--voyage-error-red, red);
    }

    .inputContainer > input::-webkit-outer-spin-button,
    .inputContainer > input::-webkit-inner-spin-button {
        -webkit-appearance: none;
        margin: 0;
    }
    .inputContainer > input[type='number'] {
        -moz-appearance: textfield;
    }

    .inputContainer > label.input-messure {
        padding-right: 10px;
        margin-bottom: 0;
        color: var(--neutrals-grey-04, grey);
    }
    .inputContainer[invalid] > label.input-messure {
        color: var(--voyage-error-red, red);
    }

    label {
        margin-bottom: 8px;
    }

    input {
        font-family: var(--component-paragraph-ff, serif);
        font-size: 14px;
        box-sizing: border-box;
        width: 100%;
        padding-left: 10px;
        padding-right: 10px;
        border: none;
        outline: none;
        color: var(--neutrals-grey-02);
        background-color: unset;
    }

    input[type='datetime-local'] {
        padding-right: 0px;
    }

    .modal-container {
        height: 100%;
    }
    .each-row-according-to-group {
        border-bottom: 1px solid #cccbcb;
        padding: 10px;
        margin: 10px;
        display: grid;
        grid-template-columns: 1fr 8fr;
        gap: 20px;
    }

    .nowButton {
        border: none;
        background: none;
        font-family: MaerskText;
        font-size: 14px;
        padding-right: 5px;
        padding-left: 5px;
        color: var(--primary-blue-05, blue);
    }
    .dropdown {
        border: none;
        width: 100%;
        height: 100%;
    }

    .dropdown[disabled] {
        background-color: var(--neutrals-grey-08, black);
    }

    .para-styles {
        color: #000000;
        font-family: MaerskText;
        font-weight: 400;
        line-height: 20px;
    }
    .loadingOverlay {
        position: absolute;
        top: -1px;
        bottom: -1px;
        right: -1px;
        left: -1px;
        z-index: 10;
        background-color: rgba(var(--neutrals-grey-01-rgb), 0.5);
        border-radius: 3px;
    }
    voyage-spinner {
        width: 50px;
        height: 50px;
        left: calc(50% - 25px);
        top: calc(50% - 25px);
        position: absolute;
    }
    .no-data {
        display: flex;
        justify-content: center;
        height: 100%;
        align-items: center;
    }
    .disable-input {
        background-color: #d9d9d9;
    }
    .center-img-no-data {
        display: flex;
        justify-content: center;
        align-items: center;
        height: 70vh;
    }
    .render-all-styles {
        overflow: hidden;
    }
    .system-generated-styles {
        background-color: #42b0d5;
        padding: 0px 6px 0px 6px;
        gap: 2px;
        border-radius: 999px;
        box-shadow: var(--ShadowHighFirstOffset-x)
            var(--ShadowHighFirstOffset-y) var(--ShadowHighFirstBlur)
            var(--ShadowHighFirstSpread) var(--ShadowHighFirstColor);
        color: #ffffff;
        font-family: MaerskText;
        font-size: 9px;
        font-weight: 700;
        line-height: 16px;
        padding-bottom: 1.5px;
    }
    .error-message {
        color: var(--voyage-error-red, red);
        font-size: 14px;
        font-weight: 400;
    }

    .suffix {
        margin-right: 10px;
        font-size: 0.9em;
        color: #666;
    }
`

export function isRequired(required: boolean) {
    return required
        ? html`<span class="required-star">*</span>`
        : html`<span class="not-required"></span>`
}

export function NoData() {
    return html`<div class="center-img-no-data">
        <img src="./assets/images/noData.svg" />
    </div>`
}

export function validations(
    item: ReportField,
    currentValue: any,
    errorMessage: string
) {
    switch (item.fieldName) {
        case 'vessel_name_repo':
            const containsSpecialChars = /[^a-zA-Z0-9 ]/g.test(currentValue)
            if (containsSpecialChars) {
                errorMessage = 'No special chars allowed'
            }
            break
        case 'imo_num_repo':
            if (!/^\d{7}$/.test(currentValue)) {
                errorMessage = 'IMO number must be exactly 7 digits'
            }
            break
        case 'arr_eosp_steaming_hours':
            const steamingHoursRegex = /^\d+(\.\d{1})?$/

            if (!steamingHoursRegex.test(currentValue)) {
                errorMessage =
                    'Steaming hours must be a number with one decimal place, e.g., 12.3 or 7.0'
            }
            break
        case 'arr_eosp_steaming_distance':
            const distanceRegex = /^(?:\d{1,3}(\.\d{1})?)$/
            const distance = parseFloat(currentValue)
            if (distance < 0 || distance > 999.9) {
                errorMessage = 'Distance must be between 0 and 999.9 NM'
            } else if (!distanceRegex.test(currentValue)) {
                errorMessage =
                    'Distance must be a number with one decimal place (e.g., 123.4 or 123)'
            }
            break
        case 'arr_eosp_average_speed':
            const speedRegex = /^(?:\d{1,3}(\.\d{1})?)$/
            if (!speedRegex.test(currentValue)) {
                errorMessage =
                    'Speed must be a number with one decimal place (e.g., 123.4 or 123)'
            } else {
                const speed = parseFloat(currentValue)
                if (speed < 0 || speed > 200.0) {
                    errorMessage = 'Speed must be between 0 and 200.0 kn'
                }
            }
            break
        case 'wind_speed':
            const isNotNumber = isNaN(currentValue)
            if (isNotNumber) {
                errorMessage = 'Wind speed must be a number'
            } 
        default:
            break
    }
    return errorMessage
}

export const latitudeRegex = /^(?:([+-]?(?:[0-8]?[0-9]|90)))°\s*([1-5]?[0-9](?:[.,][0-9]+)?)['′]?\s*(?:([1-5]?[0-9](?:[.,][0-9]+)?)["″]\s*)?([NS])$/i;
export const longitudeRegex = /^(?:([+-]?(?:180|1[0-7][0-9]|[0-9]{1,2})))°\s*([1-5]?[0-9](?:[.,][0-9]+)?)['′]?\s*(?:([1-5]?[0-9](?:[.,][0-9]+)?)["″]?\s*)?([EW])$/i;

export class CoordinateConverterReports {
    static latitudeToDecimal(coordinate: string): number {
    
        const result = latitudeRegex.exec(coordinate)
        if (result) {
            const deg = parseInt(result[1])
            const min = parseFloat(result[2])
            const sec = result[3] ? parseFloat(result[3]) : 0
            const direction = result[4].toUpperCase()

            const decimalDegrees = Math.abs(deg) + min / 60 + sec / 3600
            return direction === 'N' ? decimalDegrees : -decimalDegrees
        }

        throw new Error('Invalid latitude format.')
    }
   
    static longitudeToDecimal(coordinate: string): number {
      
        const result = longitudeRegex.exec(coordinate)

        if (result) {
            const deg = parseInt(result[1])
            const min = parseFloat(result[2])
            const sec = result[3] ? parseFloat(result[3]) : 0
            const direction = result[4].toUpperCase()

            const decimalDegrees = Math.abs(deg) + min / 60 + sec / 3600
            return direction === 'E' ? decimalDegrees : -decimalDegrees
        }

        throw new Error('Invalid longitude format.')
    }
}

export function getWindBF(windSpeed: number): number {
    if (windSpeed < 1) return 0;
    if (windSpeed >= 1 && windSpeed <= 3) return 1;
    if (windSpeed >= 4 && windSpeed <= 6) return 2;
    if (windSpeed >= 7 && windSpeed <= 10) return 3;
    if (windSpeed >= 11 && windSpeed <= 16) return 4;
    if (windSpeed >= 17 && windSpeed <= 21) return 5;
    if (windSpeed >= 22 && windSpeed <= 27) return 6;
    if (windSpeed >= 28 && windSpeed <= 33) return 7;
    if (windSpeed >= 34 && windSpeed <= 40) return 8;
    if (windSpeed >= 41 && windSpeed <= 47) return 9;
    if (windSpeed >= 48 && windSpeed <= 55) return 10;
    if (windSpeed >= 56 && windSpeed <= 63) return 11;
    return 12;
}

export function getParsedValue(value: string): boolean {
    const isNumeric = /^[+-]?\d+(\.\d+)?$/.test(value);
    return isNumeric;
}